import listHelper from "../helper/list-helper";




export const resellerListMixin = {

	data(){

		return {
			postalCodeFilter: null,
			postalCodeFilterMc: false,
			postalCodeFilterCykel: false,
			postalCodeFilterBil: false,
			postalCode: null,


		};

	},

	computed: {


		hasFilter() {
			if (this.postalCodeFilterMc && this.postalCodeFilterCykel && this.postalCodeFilterBil) {
				return false;
			}

			return this.postalCodeFilterMc || this.postalCodeFilterCykel || this.postalCodeFilterBil

		},


		postalCode5() {

			if (!this.postalCode || this.postalCode == "") {
				return false;
			}

			const string = this.postalCode.toString();

			if (string.length == 1) {
				return parseInt(string + 5555);
			}

			if (string.length == 2) {
				return parseInt(string + 555);
			}

			if (string.length == 3) {
				return parseInt(string + 55);
			}

			if (string.length == 4) {
				return parseInt(string + 5);
			}

			if (string.length >= 5) {
				return parseInt(string);
			}
			return false

		},
		resellerList() {

			var resellerList = this.baseModel?.resellerList?.filter(reseller => reseller != null);

			if (this.hasFilter) {
				resellerList = resellerList.filter(reseller => {
					if (this.postalCodeFilterMc && reseller.resellerType?.includes("M")) {
						return true;
					}

					if (this.postalCodeFilterCykel && reseller.resellerType?.includes("C")) {
						return true;
					}

					if (this.postalCodeFilterBil && reseller.resellerType?.includes("B")) {
						return true;
					}

					return false;
				})
			}

			if (this.postalCode5) {

				// nollställ distance 
				resellerList.forEach(reseller => reseller.distance = 99999)

				resellerList.map(reseller => {
					var distance = parseInt(reseller.postnumber?.replace(" ", ""));
					distance = Math.abs(this.postalCode5 - distance)
					reseller.distance = distance
					return reseller;
				})

				return resellerList.sort((a, b) => { return a.distance - b.distance })
				//return [];
			}

			if (this.postalCodeFilter) {
				resellerList = listHelper.filterList(resellerList, this.postalCodeFilter)
			}

			return resellerList;
		},

		resellerModel() {

			var resellerList = this.resellerList?.filter(reseller => reseller != null)

			var model = new Map();

			resellerList?.sort((a, b) => a.name?.localeCompare(b.name))?.forEach(reseller => {

				const firstLetter = reseller.name?.charAt(0)?.toUpperCase();

				var letterList = model.get(firstLetter);

				if (!letterList) {
					letterList = [];
				}

				letterList.push(reseller)

				model.set(firstLetter, letterList);



			});

			return model;
		},
		resultLabel() {

			if (!this.resellerList) {
				return "";
			}

			if (this.resellerList?.length == 1) {
				return "Hittade en återförsäljare"
			}

			if (this.resellerList?.length > 1) {
				return "Hittade " + this.resellerList.length + " återförsäljare"
			}

			return "";

		}
	


	},

	methods: {

		

	}
}



